import { useEffect, useState } from 'react';

const canMatch = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

/**
 * One-time check of a CSS media query, for defaults decided at mount (e.g. a
 * panel that starts open on desktop). `fallback` applies where matchMedia
 * isn't available.
 */
export function matchesMedia(query, fallback = false) {
    return canMatch() ? window.matchMedia(query).matches : fallback;
}

/** Live boolean for a CSS media query; updates when the query starts or stops matching. */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => matchesMedia(query));

    useEffect(() => {
        if (!canMatch()) return undefined;
        const mql = window.matchMedia(query);
        const onChange = () => setMatches(mql.matches);
        onChange();
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}
